import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
declare var $: any;

@Component({
    selector: 'app-summernote-editor',
    templateUrl: './summernote-editor.component.html',
    styleUrls: ['./summernote-editor.component.scss'],
})
export class SummernoteEditorComponent implements OnInit, OnChanges, OnDestroy {
    @ViewChild('summernote') summernote: ElementRef;
    @Input() formControl!: FormControl;
    @Input() initialHtml: string = '';
    @Output() contentChanged: EventEmitter<string> = new EventEmitter();

    private previousContent: string = '';
    private isInitialized = false;
    private ignoreNextChange = false;
    private updateTimeout: any;

    config = {
        placeholder: '',
        tabsize: 2,
        height: 400,
        callbacks: {
            onChange: (contents: string) => {
                if (!this.ignoreNextChange) {
                    requestAnimationFrame(() => {
                        this.onContentChange(contents);
                    });
                }
            },
            onInit: () => {
                this.isInitialized = true;
                if (this.initialHtml) {
                    this.forceUpdate(this.initialHtml);
                }
            }
        },
        toolbar: [
            ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
            ['misc', ['codeview', 'undo', 'redo']],
            ['fontsize', ['fontsize', 'color']],
            ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
            ['insert', ['table', 'picture', 'link', 'hr']],
        ],
    };

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.initializeSummernote();
    }

    ngOnDestroy(): void {
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
        }
        if (this.summernote?.nativeElement) {
            const $summernote = $(this.summernote.nativeElement);
            if ($summernote.summernote) {
                $summernote.summernote('destroy');
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['initialHtml']) {
            const newContent = changes['initialHtml'].currentValue;
            if (newContent !== this.previousContent) {
                this.previousContent = newContent;
                this.forceUpdate(newContent);
            }
        }
    }

    public forceUpdate(content: string): void {
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
        }

        this.updateTimeout = setTimeout(() => {
            if (this.summernote?.nativeElement) {
                const $summernote = $(this.summernote.nativeElement);
                if ($summernote.summernote) {
                    this.ignoreNextChange = true;
                    $summernote.summernote('code', content);
                    setTimeout(() => {
                        this.ignoreNextChange = false;
                    }, 0);
                }
            }
        }, 0);
    }

    private initializeSummernote(): void {
        if (this.summernote?.nativeElement && !this.isInitialized) {
            const $summernote = $(this.summernote.nativeElement);
            if (!$summernote.hasClass('note-editor')) {
                $summernote.summernote(this.config);
            }
        }
    }

    onContentChange(content: string): void {
        if (!this.ignoreNextChange && content !== this.previousContent) {
            this.previousContent = content;
            this.contentChanged.emit(content);
            this.cdr.detectChanges();
        }
    }

    resetEditor(): void {
        if (this.summernote?.nativeElement) {
            const $summernote = $(this.summernote.nativeElement);
            this.ignoreNextChange = true;
            $summernote.summernote('reset');
            $summernote.summernote('code', '');
            this.contentChanged.emit('');
            setTimeout(() => {
                this.ignoreNextChange = false;
            }, 0);
        }
    }
}